var map = {
	"./frontend/AndroidGuide.vue": 3110,
	"./frontend/Banking.vue": 5413,
	"./frontend/BetslipHistory.vue": 4355,
	"./frontend/BodyFB.vue": 4805,
	"./frontend/Commission.vue": 8679,
	"./frontend/ContactUs.vue": 477,
	"./frontend/DataTable.vue": 818,
	"./frontend/Deposit.vue": 8798,
	"./frontend/History.vue": 8397,
	"./frontend/Home.vue": 4644,
	"./frontend/IOSGuide.vue": 9210,
	"./frontend/Iframe copy.vue": 3020,
	"./frontend/Iframe.vue": 3279,
	"./frontend/Index.vue": 6781,
	"./frontend/Live.vue": 6804,
	"./frontend/LiveScore.vue": 5634,
	"./frontend/MainMenu.vue": 4694,
	"./frontend/MaungFB.vue": 4077,
	"./frontend/Promotion.vue": 4579,
	"./frontend/Setting.vue": 1424,
	"./frontend/VideoLink.vue": 1601,
	"./frontend/VipLevels.vue": 8076,
	"./frontend/Withdraw.vue": 8826,
	"./frontend/auth/Login.vue": 1944,
	"./frontend/auth/Register.vue": 3909,
	"./frontend/auth/Rule.vue": 2251,
	"./frontend/auth/Verify.vue": 7223,
	"./frontend/auth/VerifyNotAuth.vue": 2739,
	"./frontend/components/AccountSelect.vue": 6311,
	"./frontend/components/DataTable.vue": 8344,
	"./frontend/components/FBPreviewVoucher.vue": 3190,
	"./frontend/components/FBVoucher.vue": 4528,
	"./frontend/components/FootballTeamCard.vue": 1430,
	"./frontend/components/GroupBox.vue": 3593,
	"./frontend/components/InputSelectDrawModal.vue": 7621,
	"./frontend/components/LuckyWheel.vue": 4223,
	"./frontend/components/NormalBox.vue": 6251,
	"./frontend/components/PreviewVoucher.vue": 4566,
	"./frontend/components/SideNav.vue": 1604,
	"./frontend/components/Table.vue": 3406,
	"./frontend/components/ThreedGroupBox.vue": 5327,
	"./frontend/components/TwoDSelect.vue": 8796,
	"./frontend/components/Voucher.vue": 9247,
	"./frontend/normal-user/2d/2d.vue": 1543,
	"./frontend/normal-user/2d/ClosedDays.vue": 2083,
	"./frontend/normal-user/2d/Home.vue": 3034,
	"./frontend/normal-user/2d/Winner.vue": 24,
	"./frontend/normal-user/3d/3d.vue": 6543,
	"./frontend/normal-user/3d/Home.vue": 9750,
	"./frontend/normal-user/DreamBooks.vue": 6547,
	"./frontend/normal-user/Index.vue": 5531,
	"./frontend/normal-user/bugyee/Room.vue": 2365,
	"./frontend/normal-user/game/Arcade.vue": 8535,
	"./frontend/normal-user/game/Fishing.vue": 5072,
	"./frontend/normal-user/game/Game.vue": 5839,
	"./frontend/normal-user/game/Slot.vue": 4099,
	"./frontend/normal-user/shankomee/Room.vue": 6929
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7057;